module.exports = __webpack_public_path__ + "static/media/logo-white.27aa7520.svg";